import { render, staticRenderFns } from "./PesquisaGlobal.vue?vue&type=template&id=27435988&"
import script from "./PesquisaGlobal.vue?vue&type=script&lang=js&"
export * from "./PesquisaGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports